import React from 'react';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import PlaceHolder from '../../Data/Assets/images/iyns_placeholder.png';
import content from '../../Data/Events';
import imageMap from '../../Data/ImageMap';
import './EventsPage.css';
function EventsPage() {
  return (
    <div>
      <Navbar></Navbar>
      <div className="event-page-container">
        <div className="event-page hero-section">
          <div className="hero-section-title">Activities / Events</div>
          <div className="hero-section-description">
            <p className="description-text">
              Join IYNS to support nuclear science outreach and research. Work on live projects,
              create content, organize events, and connect with experts worldwide.
            </p>
          </div>
          <div className="hero-section-image">
            <img className="section-image" src={PlaceHolder} alt="event-img"></img>
          </div>
        </div>
        <div className="events-listing-section">
          <div className="events-past-future-buttons">
            <button className="upcoming-button">Upcoming</button>
            <button className="past-event-button">Past Event</button>
          </div>
          <div className="events-listing events-list">
            {content.cards.map((card, index) => {
              return (
                <div key={index} className="event-list-card">
                  <div className="card-content-container">
                    <div className="card-title-descrition">
                      <p className="card-title-text">{card.title_section.title}</p>
                      <p className="card-description">{card.title_section.description}</p>
                    </div>
                  </div>
                  <div className="year-month-date-time">
                    <div className="publishing-date">
                      <div className="publishing-day">{card.info_section.date.day}</div>
                      <div className="publishing-year-month">
                        <div className="publishing-month">{card.info_section.date.month}</div>
                        <div className="publishing-year">{card.info_section.date.year}</div>
                      </div>
                    </div>
                    <div className="publishing-time">
                      <div className="publishing-time-hour">{card.info_section.date.time}</div>
                      <div className="publishing-time-am_pm">{card.info_section.date.am_pm}</div>
                    </div>
                  </div>
                  <div className="card-img">
                    <img
                      src={imageMap[card.image_section.image]}
                      className="event-image"
                      alt="article_img"
                    ></img>
                  </div>
                  <div className="event-card-buttons">
                    <button className="register-button">{card.buttons[0].label}</button>
                    <button className="know-more-button">{card.buttons[1].label}</button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default EventsPage;
